import css from 'styled-jsx/css';

const styles = css.global`

body {
    -webkit-font-smoothing: antialiased;
}

#banco-auto-25-banner {
    overflow: hidden;
    background: #ec0000;
}


#banco-auto-25-banner .bg-hero img {
    width: 100%;
    object-fit: cover;
    height: 450px;
    position: absolute;
    max-height: 450px;
    min-height: 408px;

}


#banco-auto-25-banner .ctn-home-24 {
    position: relative;
}

#banco-auto-25-banner .hero-contain {
    height: 450px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 24px;
    padding-top: 40px;
    padding-bottom: 34px;
    max-height: 450px;
    min-height: 408px;
}

#banco-auto-25-banner .hero-title {
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
    color: #FFFFFF;
    max-width: 230px;
}

#banco-auto-25-banner .hero-sub-title {
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    color: #FFFFFF;
}

#banco-auto-25-banner .hero-buttons {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    margin-bottom: 20px;
}

#banco-auto-25-banner .hero-buttons a {
    width: 100%;
    max-width: 272px;
    margin: auto;
    border-radius: 80px;
    height: 50px;
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 5px;
}

#banco-auto-25-banner .img-hero-desk {
    display: none;
}

@media (min-width: 451px) {
    #banco-auto-25-banner .bg-hero img {
        object-fit: contain;
    }
}

@media (min-width: 601px) {
    #banco-auto-25-banner {
        height: 400px;
    }
    #banco-auto-25-banner .bg-hero picture {
        position: absolute;
        /* height: 100%; */
        width: 100%;
        left: 50%;
        transform: translate(-50%, 0);
    }

    #banco-auto-25-banner .fade-hero-santander,
    #banco-auto-25-banner .bg-hero img {
        height: 400px;
        /* min-height: 400px;
        max-height: 400px; */
        position: initial;
        object-fit: contain;
        object-position: -65px;
    }

    #banco-auto-25-banner .hero-contain {
        align-items: flex-start;
        padding-top: 48px;
        padding-bottom: 34px;
        height: 400px;
        /* min-height: 400px;
        max-height: 400px; */
        justify-content: flex-end;
    }

    #banco-auto-25-banner .hero-title {
        font-size: 64px;
        line-height: 120%;
        width: 100%;
        max-width: 832px;
        z-index: 2;
        position: relative;
        max-width: 410px;
    }

    #banco-auto-25-banner .hero-sub-title {
        font-size: 32px;
        line-height: 120%;
        width: 100%;
        max-width: 716px;
        margin-top: 16px;
        z-index: 2;
        position: relative;
    }

    #banco-auto-25-banner .hero-buttons {
        align-items: flex-start;
        gap: 16px;
        z-index: 2;
        padding-left: 0;
        margin-bottom: 40px;
    }

    #banco-auto-25-banner .hero-buttons a {
        margin: 0;
        max-width: 190px;
    }

}

@media (min-width: 800px) {
    #banco-auto-25-banner .ctn-home-24 {
        max-width: 800px;
        padding-right: 45px;
        padding-left: 45px;
    }

    #banco-auto-25-banner .bg-hero img {
        object-position: -45px;
    }

    #banco-auto-25-banner .hero-buttons {
        padding-left: 0;
        margin-bottom: 20px;
    }
    
    #banco-auto-25-banner .hero-buttons a {
        max-width: 220px;
    }
}

@media (min-width: 992px) {
    /* #banco-auto-25-banner .bg-hero img {
        object-position: right;
    } */
    #banco-auto-25-banner .hero-title {
        max-width: 610px;
    }

    #banco-auto-25-banner .hero-buttons {
        padding-left: 0;
        margin-bottom: 30px;
    }
}

@media (min-width: 1281px) {
    #banco-auto-25-banner .ctn-home-24 {
        max-width: 1208px;
        padding-right: 0;
        padding-left: 0;
    }
    
    #banco-auto-25-banner .hero-buttons a {
        max-width: 272px;
    }
    
    #banco-auto-25-banner .hero-buttons {
        padding-left: 54px;
        margin-bottom: 10px;
    }
}
`;

export default styles;